import React, { createContext, useContext, useState } from 'react';

// Create the context
const ActiveCodeContext = createContext();

// Provider component
export const ActiveCodeProvider = ({ children, initialCodeId = null }) => {
  const [activeCodeId, setActiveCodeId] = useState(initialCodeId);

  return (
    <ActiveCodeContext.Provider value={{ activeCodeId, setActiveCodeId }}>
      {children}
    </ActiveCodeContext.Provider>
  );
};

// Custom hook to use the context
export const useActiveCode = () => {
  const context = useContext(ActiveCodeContext);
  
  if (!context) {
    throw new Error('useActiveCode must be used within an ActiveCodeProvider');
  }
  
  return context;
};